import type { UserEditableData, User, UserChangeEmailData } from '@/types';
import request from '@/utils/request';

export const GET_USER_URL = '/api/v1/users/me/';

export const getUser = async (): Promise<any> => {
  return (await request.get(GET_USER_URL)).data as User;
};

export const CREATE_USER_URL = '/api/v1/users/registrations/';

export const createUser = async ({
  userEmail,
  userPassword,
  organizationInviteToken,
}: UserEditableData): Promise<any> => {
  return await request.post(CREATE_USER_URL, {
    userEmail: userEmail.toLowerCase(),
    userPassword,
    organizationInviteToken,
  });
};

export const createUserVerify = async (registrationRequestId: string): Promise<any> => {
  return await request.patch(CREATE_USER_URL, { registrationRequestId });
};

export const CHANGE_USER_EMAIL = '/api/v1/users/emails/';

export const changeEmail = async ({ newUserEmail, isPrimary, password }: UserChangeEmailData): Promise<any> => {
  return await request.post(CHANGE_USER_EMAIL, {
    newUserEmail: newUserEmail.toLowerCase(),
    isPrimary,
    password,
  });
};

export const CHANGE_USER_EMAIL_VERIFY = '/api/v1/users/emails/verification/';

export const changeEmailVerify = async (verificationRequestId: string): Promise<any> => {
  return await request.patch(CHANGE_USER_EMAIL_VERIFY, { verificationRequestId });
};

export const EMAIL_UNSUBSCRIBE_URL = '/api/v1/email-unsubscribe/';

export const unsubscribeFromEmails = async (token: string): Promise<void> => {
  await request.post(EMAIL_UNSUBSCRIBE_URL, { token });
};
